export const activityTypes = [
    {
        value: "course",
        label: "课程",
    },
    {
        value: "couponPackage",
        label: "券包",
    },
    {
        value: "couponPackageGet",
        label: "发券包",
    },
    {
        value: "joint",
        label: "课程联报",
    },
    {
        value: "show",
        label: "活动展示",
    },
]


export const ruleType = [
    {
        value: "discount",
        label: "折扣",
    },
    {
        value: "reduce",
        label: "金额优惠",
    },
    {
        value: "cashBack",
        label: "比例返现",
    },
    {
        value: "cashBackA",
        label: "金额返现",
    },
    {
        value: "gift",
        label: "礼物",
    }
]


export const conditionType = [
    {
        value: "category",
        label: "主类目"
    },
    {
        value: "category1",
        label: "一级类目"
    },
    {
        value: "category2",
        label: "二级类目"
    }
]



export const mainCategory = [
    {
        value: "体育运动",
        label: "体育运动"
    },
    {
        value: "休闲生活",
        label: "休闲生活"
    }
    , {
        value: "夜校",
        label: "夜校"
    }
]